import { z } from 'zod';

export const AssetLocationKind = z.enum(['store', 'assetLocation']);
export type AssetLocationKind = z.infer<typeof AssetLocationKind>;
